export const HAZARD_CLASS_OPTIONS = [
  { key: '1.1A', name: '1.1A' },
  { key: '1.1A, 6.1', name: '1.1A, 6.1' },
  { key: '1.1B', name: '1.1B' },
  { key: '1.1C', name: '1.1C' },
  { key: '1.1D', name: '1.1D' },
  { key: '1.1D, 6.1', name: '1.1D, 6.1' },
  { key: '1.1E', name: '1.1E' },
  { key: '1.1F', name: '1.1F' },
  { key: '1.1G', name: '1.1G' },
  { key: '1.1J', name: '1.1J' },
  { key: '1.1L', name: '1.1L' },
  { key: '1.2B', name: '1.2B' },
  { key: '1.2C', name: '1.2C' },
  { key: '1.2D', name: '1.2D' },
  { key: '1.2E', name: '1.2E' },
  { key: '1.2F', name: '1.2F' },
  { key: '1.2G', name: '1.2G' },
  { key: '1.2G, 8, 6.1', name: '1.2G, 8, 6.1' },
  { key: '1.2H', name: '1.2H' },
  { key: '1.2J', name: '1.2J' },
  { key: '1.2K, 6.1', name: '1.2K, 6.1' },
  { key: '1.2L', name: '1.2L' },
  { key: '1.3C', name: '1.3C' },
  { key: '1.3C, 6.1', name: '1.3C, 6.1' },
  { key: '1.3G', name: '1.3G' },
  { key: '1.3G, 8, 6.1', name: '1.3G, 8, 6.1' },
  { key: '1.3H', name: '1.3H' },
  { key: '1.3J', name: '1.3J' },
  { key: '1.3K, 6.1', name: '1.3K, 6.1' },
  { key: '1.3L', name: '1.3L' },
  { key: '1.4B', name: '1.4B' },
  { key: '1.4C', name: '1.4C' },
  { key: '1.4D', name: '1.4D' },
  { key: '1.4E', name: '1.4E' },
  { key: '1.4F', name: '1.4F' },
  { key: '1.4G', name: '1.4G' },
  { key: '1.4G, 8, 6.1', name: '1.4G, 8, 6.1' },
  { key: '1.4S', name: '1.4S' },
  { key: '1.5D', name: '1.5D' },
  { key: '1.6N', name: '1.6N' },
  { key: '2.1', name: '2.1' },
  { key: '2.1, 6.1', name: '2.1, 6.1' },
  { key: '2.1, 8', name: '2.1, 8' },
  { key: '2.2', name: '2.2' },
  { key: '2.2, 5.1', name: '2.2, 5.1' },
  { key: '2.2, 6.1', name: '2.2, 6.1' },
  { key: '2.2, 8', name: '2.2, 8' },
  { key: '2.3', name: '2.3' },
  { key: '2.3, 2.1', name: '2.3, 2.1' },
  { key: '2.3, 2.1, 8', name: '2.3, 2.1, 8' },
  { key: '2.3, 5.1', name: '2.3, 5.1' },
  { key: '2.3, 5.1, 8', name: '2.3, 5.1, 8' },
  { key: '2.3, 8', name: '2.3, 8' },
  { key: '2.3, 8, 5.1', name: '2.3, 8, 5.1' },
  { key: '3', name: '3' },
  { key: '3, 6.1', name: '3, 6.1' },
  { key: '3, 6.1, 8', name: '3, 6.1, 8' },
  { key: '3, 8', name: '3, 8' },
  { key: '4.1', name: '4.1' },
  { key: '4.1, 5.1', name: '4.1, 5.1' },
  { key: '4.1, 6.1', name: '4.1, 6.1' },
  { key: '4.1, 8', name: '4.1, 8' },
  { key: '4.2', name: '4.2' },
  { key: '4.2, 4.3', name: '4.2, 4.3' },
  { key: '4.2, 5.1', name: '4.2, 5.1' },
  { key: '4.2, 6.1', name: '4.2, 6.1' },
  { key: '4.2, 8', name: '4.2, 8' },
  { key: '4.3', name: '4.3' },
  { key: '4.3, 3', name: '4.3, 3' },
  { key: '4.3, 3, 8', name: '4.3, 3, 8' },
  { key: '4.3, 4.1', name: '4.3, 4.1' },
  { key: '4.3, 4.2', name: '4.3, 4.2' },
  { key: '4.3, 5.1', name: '4.3, 5.1' },
  { key: '4.3, 6.1', name: '4.3, 6.1' },
  { key: '4.3, 8', name: '4.3, 8' },
  { key: '4.3, 8, 3', name: '4.3, 8, 3' },
  { key: '5.1', name: '5.1' },
  { key: '5.1, 4.1', name: '5.1, 4.1' },
  { key: '5.1, 4.2', name: '5.1, 4.2' },
  { key: '5.1, 4.3', name: '5.1, 4.3' },
  { key: '5.1, 6.1', name: '5.1, 6.1' },
  { key: '5.1, 6.1, 8', name: '5.1, 6.1, 8' },
  { key: '5.1, 8', name: '5.1, 8' },
  { key: '5.2', name: '5.2' },
  { key: '5.2, 1', name: '5.2, 1' },
  { key: '6.1', name: '6.1' },
  { key: '6.1, 3', name: '6.1, 3' },
  { key: '6.1, 3, 8', name: '6.1, 3, 8' },
  { key: '6.1, 4.1', name: '6.1, 4.1' },
  { key: '6.1, 4.2', name: '6.1, 4.2' },
  { key: '6.1, 4.3', name: '6.1, 4.3' },
  { key: '6.1, 4.3, 3', name: '6.1, 4.3, 3' },
  { key: '6.1, 5.1', name: '6.1, 5.1' },
  { key: '6.1, 7, 8', name: '6.1, 7, 8' },
  { key: '6.1, 8', name: '6.1, 8' },
  { key: '6.1, 8, 3', name: '6.1, 8, 3' },
  { key: '6.2', name: '6.2' },
  { key: '7', name: '7' },
  { key: '7, 6.1, 8', name: '7, 6.1, 8' },
  { key: '8', name: '8' },
  { key: '8, 3', name: '8, 3' },
  { key: '8, 3, 6.1', name: '8, 3, 6.1' },
  { key: '8, 4.1', name: '8, 4.1' },
  { key: '8, 4.2', name: '8, 4.2' },
  { key: '8, 4.3', name: '8, 4.3' },
  { key: '8, 5.1', name: '8, 5.1' },
  { key: '8, 5.1, 6.1', name: '8, 5.1, 6.1' },
  { key: '8, 6.1', name: '8, 6.1' },
  { key: '8, 6.1, 3', name: '8, 6.1, 3' },
  { key: '9', name: '9' },
];

export const PACKING_GROUP_OPTIONS = [
  { key: 'i', name: 'I' },
  { key: 'ii', name: 'II' },
  { key: 'iii', name: 'III' },
  { key: 'NoPackagingGroup', name: 'No Packaging Group' },
];

export const HAZMAT_UN_NA_MAX_LENGTH = 30;
export const HAZMAT_ERG_REFERENCE_MAX_LENGTH = 4;
export const HAZMAT_FLASHPOINT_MAX_TEMP_F = 999;
export const HAZMAT_SHIPPING_NAME_MAX_LENGTH = 100;
export const HAZMAT_EMERGENCY_CONTACT_NAME_MAX_LENGTH = 30;
export const HAZMAT_EMERGENCY_PHONE_MAX_LENGTH = 30;
export const HAZMAT_ADDITIONAL_DETAILS_MAX_LENGTH = 250;
